__turbopack_context__.v({
  "dialog": "AccountPanel-module__bBCC2W__dialog",
  "header": "AccountPanel-module__bBCC2W__header",
  "overlay": "AccountPanel-module__bBCC2W__overlay",
  "panel": "AccountPanel-module__bBCC2W__panel",
});
